<template>
  <div v-if="!loading">
    <v-alert
      v-if="form.swot_socialny_podnik_dostupny || form.swot_socialny_podnik_akceptovany_nazov || form.swot_zabezpecena_nadvazna_starostlivost || form.swot_poziadal_o_spolupracu_obec"
      dense
      outlined
      color="info"
    >
      <v-row v-if="form.swot_socialny_podnik_dostupny || form.swot_socialny_podnik_akceptovany_nazov">
        <v-col cols="auto">
          Klient prejavil záujem o prácu v sociálnom podniku.
          <span v-if="form.swot_socialny_podnik_akceptovany_nazov">
            Bol prejavený záujem zo strany sociálneho podniku <strong>{{form.swot_socialny_podnik_akceptovany_nazov}}</strong>, klient ponuku akceptoval.</span>
        </v-col>
      </v-row>
      <v-row v-if="form.swot_zabezpecena_nadvazna_starostlivost">
        <v-col>
          Klient prejavil záujem o riešenie problému v organizácii <strong>{{form.swot_zabezpecena_nadvazna_starostlivost_text}}</strong>.
        </v-col>
      </v-row>

      <v-row v-if="form.swot_poziadal_o_spolupracu_obec">
        <v-col>
          Klient prejavil požiadal o súčinnosť obec/mesto <strong>{{form.swot_poziadal_o_spolupracu_obec_text}}</strong>.
        </v-col>
      </v-row>
    </v-alert>

    <form>
      <!-- <h1 class="title font-weight-regular">
        Informácie pracovníkov UVTOS:
      </h1>

      <v-row
        v-for="(input, index) in form.informacie_uvtos"
        :key="input.id"
        dense
      >
        <v-col
          md="1"
          sm="12"
          cols="12"
        >
          <v-text-field
            v-model="input.datum"
            label="Dátum"
            name="Dátum"
            class="pr-2"
          />
        </v-col>

        <v-col
          md="11"
          sm="12"
          cols="12"
        >
          <v-textarea
            v-model="input.text"
            :disabled="form.closed"
            label="Popis"
            name="Popis"
            rows="1"
            auto-grow
            append-icon="mdi-delete"
            @click:append="deleteRowInformacieUVTOS(index)"
          />
        </v-col>
        <v-col
          md="12"
          sm="12"
          cols="12"
        >
          <hidden-attachments
            :size="input.files.length"
            v-if="input.id"
          >
            <v-card>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Meno
                        </th>
                        <th class="text-left">
                          Čas pridania
                        </th>
                        <th class="text-left">
                          Akcie
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in input.files"
                        :key="item.id"
                      >
                        <td>{{ item.name }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>
                          <v-btn
                            small
                            @click="downloadAttachment(item)"
                          >Stiahnuť súbor</v-btn>
                          <v-btn
                            small
                            color="error"
                            class="ml-10"
                            @click="deleteAttachmentUVTOS(item)"
                          >Zmazať súbor</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="10">

                    <v-file-input
                      show-size
                      v-model="input.file"
                      label="Súbor"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      color="info"
                      @click="uploadFileUVTOS(input.file, input.id)"
                    >Upload</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </hidden-attachments>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            text
            icon
            color="secondary"
            @click="addRowInformacieUVTOS"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row> -->

      <h1 class="title font-weight-regular">
        Informácie pracovníkov UPSVR:
      </h1>

      <v-row
        v-for="(input, index) in form.informacie_upsvar"
        :key="index"
        dense
      >
        <v-col
          md="2"
          sm="12"
          cols="12"
        >
          <v-text-field
            v-model="input.datum"
            label="Dátum"
            name="Dátum"
            class="pr-2"
          />
        </v-col>

        <v-col
          md="10"
          sm="12"
          cols="12"
        >
          <v-textarea
            v-model="input.text"
            :disabled="form.closed"
            label="Popis"
            name="Popis"
            rows="1"
            auto-grow
            append-icon="mdi-delete"
            @click:append="deleteRowInformacieUPSVAR(index)"
          />
        </v-col>

        <v-col
          cols="12"
          v-if="input.id"
        >

          <hidden-attachments :size="input.files.length">
            <v-card>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Meno
                        </th>
                        <th class="text-left">
                          Čas pridania
                        </th>
                        <th class="text-left">
                          Akcie
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in input.files"
                        :key="item.id"
                      >
                        <td>{{ item.name }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>
                          <v-btn
                            small
                            @click="downloadAttachment(item)"
                          >Stiahnuť súbor</v-btn>
                          <v-btn
                            small
                            color="error"
                            class="ml-10"
                            @click="deleteAttachmentUPSVAR(item)"
                          >Zmazať súbor</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="10">

                    <v-file-input
                      show-size
                      v-model="input.file"
                      label="Súbor"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      color="info"
                      @click="uploadFileUPSVAR(input.file, input.id)"
                    >Upload</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

          </hidden-attachments>
        </v-col>

      </v-row>

      <v-btn
        text
        icon
        color="secondary"
        @click="addRowInformacieUPSVAR"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          class="ma-2"
          fixed
          right
          bottom
          dark
          rounded
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="AktualnyStav" />
  </div>

</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import HiddenAttachments from "../components/HiddenAttachments.vue";


const apiService = new APIService();

export default {

  components: {
    "form-skeleton-component": FormSkeleton,
    "hidden-attachments": HiddenAttachments
  },

  data: () => ({
    uploading: false,
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,

    form: {
      id: null,
      informacie_uvtos: [
        {
          datum: "",
          text: "",
        },
      ],
      informacie_upsvr: [
        {
          datum: "",
          text: "",
        },
      ],
    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    downloadAttachment(item) {
      apiService.downloadItem(item.file, item.name);
    },

    deleteAttachmentUVTOS(item) {
      apiService.deleteInformacieUVTOSFile(item).then(() => this.getItem()
      );
    },

    uploadFileUVTOS(file, id) {
      this.uploading = true;

      let formData = new FormData();
      formData.set("informacie_uvtos", id);

      if (file instanceof File)
        formData.append("file", file);
      formData.append("name", file.name);


      apiService.createInformacieUVTOSFile(formData).then(
        (response) => {
          this.snackbar_saved = true;
          this.getItem();
        },
        () => {
          this.uploading = false;
          this.snackbar_error = true;
        }
      );
    },

    deleteAttachmentUPSVAR(item) {
      apiService.deleteInformacieUPSVARFile(item).then(() => this.getItem()
      );
    },

    uploadFileUPSVAR(file, id) {
      let formData = new FormData();
      formData.set("informacie_upsvar", id);

      if (file instanceof File)
        formData.append("file", file);
      formData.append("name", file.name);


      apiService.createInformacieUPSVARFile(formData).then(
        (response) => {
          this.snackbar_saved = true;
          this.getItem();
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },


    getItem() {
      apiService
        .getIapszAktualnyStav(this.$route.params.id)
        .then((response) => {
          this.form = response;
        });
    },


    updateItem() {
      apiService.updateIapszAktualnyStav(this.form, this.$route.params.id).then(
        (response) => {
          this.snackbar_saved = true;
          this.form = response;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    addRowInformacieUVTOS() {
      this.form.informacie_uvtos.push({
        aktualny_stav: this.form.id,
        datum: null,
        text: null,
        files: []
      });
    },
    deleteRowInformacieUVTOS(index) {
      this.form.informacie_uvtos.splice(index, 1);
    },
    addRowInformacieUPSVAR() {
      this.form.informacie_upsvar.push({
        aktualny_stav: this.form.id,
        datum: null,
        text: null,
        files: []
      });
    },
    deleteRowInformacieUPSVAR(index) {
      this.form.informacie_upsvar.splice(index, 1);
    },
  },
};
</script>